import React from 'react';
import { compose, lifecycle, withState, withHandlers, withProps } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import { get, omit, filter } from 'lodash';
import { getProduct, getItem, updateItem, addAttributeItemValue } from './_api';
import AddItemForm from './form/addItemForm';
import { withSnackbar } from 'notistack';
import { getCategory } from '../categories/_api';
import { attributeValueGet } from '../app/_api';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
});

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  withRouter,
  withState('item', 'setItem', null),
  withState('product', 'setProduct', null),
  withState('categoryAttr', 'setCategoryAttr', null),
  withProps(
    ({
      match: {
        params: { productId, itemId },
      },
    }) => {
      return { productId, itemId };
    }
  ),
  withProps(({ item }) => {
    let initialAttributes = [];
    get(item, 'attributes', []).map((item) => {
      initialAttributes[item.attributeId] = item.id;
      return '';
    });
    return { initialAttributes };
  }),
  lifecycle({
    async componentDidMount() {
      const { toggleLoader, itemId, setItem, productId, setProduct, setCategoryAttr } = this.props;
      toggleLoader();
      const resp = await getItem(itemId);
      if (resp) {
        setItem(resp);
        const resp2 = await getProduct(productId);
        if (resp2) {
          setProduct(resp2);
          const resp3 = await getCategory(resp2.categoryId);
          if (resp3) {
            Promise.all(
              get(resp3, 'attributes', []).map(async (item) => {
                const values = await attributeValueGet(item.id);
                return { ...item, values: values.items };
              })
            ).then((values) => setCategoryAttr(filter(values, (item) => item.level === 4)));
          }
        }
      }
      toggleLoader(false);
    },
  }),
  withHandlers({
    onSubmit: ({ itemId, enqueueSnackbar, history, productId }) => async (values) => {
      if (get(values, 'attributes', false)) {
        await addAttributeItemValue(itemId, values.attributes);
      }
      const resp = await updateItem(omit(values, ['attribute']));
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Položka byla uložena.', { variant: 'success' });
        history.push(`/products/${productId}`);
      } else {
        enqueueSnackbar('Položka se nepodařilo uložit.', { variant: 'error' });
      }
    },
  })
);

export default enhance(
  ({ classes, onSubmit, item, productId, product, categoryAttr, initialAttributes }) => (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {item && product && (
          <AddItemForm
            productId={productId}
            attributes={categoryAttr}
            onSubmit={onSubmit}
            initialValues={{
              price: get(item, 'price', null),
              serialNumber: get(item, 'serialNumber', null),
              id: get(item, 'id', null),
              status: get(item, 'status'),
              attributes: initialAttributes,
            }}
          />
        )}
      </Paper>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/products/detailItem.js